module.exports = __webpack_public_path__ + "img/p3-right.bed96cab.svg";